import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
};

const MainContentFixed = ({ children, className, size = 'md' }) => {
  const classes = classNames({
    'pro-wrapper-main-content-fixed': true,
    'is-extra-large': size === 'xl',
    'is-large': size === 'lg',
    'is-small': size === 'sm',
    [className]: !!className,
  });

  return <div className={classes}>{children}</div>;
};

MainContentFixed.propTypes = propTypes;

export default MainContentFixed;
